import React, { useMemo } from 'react'
import { BaseEditorField } from 'src/editor/shared/entities/base-editor-field'
import { FormBaseSubentity } from './form-base-subentity'
import {
  FormFieldInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { contactFieldLocoKeys } from 'src/editor/shared/utils/get-contact-field-title'

interface FormFieldSubentityProps {
  formEntity: FormInterface
  fieldSubentity: FormFieldInterface
}

export const FormFieldSubentity = ({
  formEntity,
  fieldSubentity,
}: FormFieldSubentityProps) => {
  const entity = useMemo(
    () => ({
      ...fieldSubentity,
      ...formEntity.fieldsCommonStyles,
    }),
    [fieldSubentity, formEntity.fieldsCommonStyles],
  )

  return (
    <FormBaseSubentity
      title={contactFieldLocoKeys[fieldSubentity.slug]}
      formEntity={formEntity}
      subentity={fieldSubentity}
    >
      <BaseEditorField entity={entity} />
    </FormBaseSubentity>
  )
}
